/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LibraryLoginService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Login a user that already exists and return their userID.
     * If the user does not exist, throw an error.
     * If the user password is incorrect throw an error.
     * @param userName the email of the given user
     * @param password the hashed password for the given user
     * @returns any Ok
     * @throws ApiError
     */
    public loginAndReturnExistingUser(
        userName: string,
        password: string,
    ): CancelablePromise<{
        userId: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/libraryLogin',
            query: {
                'userName': userName,
                'password': password,
            },
        });
    }

    /**
     * Create a new user in the db.
     * Throw an error if the email is already in use
     * @param userName the email of the given user
     * @param password the hashed password for the given user
     * @returns any Ok
     * @throws ApiError
     */
    public createNewUser(
        userName: string,
        password: string,
    ): CancelablePromise<{
        userId: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/libraryLogin',
            query: {
                'userName': userName,
                'password': password,
            },
        });
    }

}
